// Was declared without an `export`, so the (unrouted) page importing it would
// have crashed the moment it got a route. Named export, matching the other
// items files.
export const extracurricularItems = [
    {
        name: "Trinity College Football Team",
        date: "2022-2024",
        description: "Played for the college team",
    },
    {
        name: "Trinity College Ultimate Frisbee Team",
        date: "2022-2025",
        description: "Played for the college team",
    }
];